module.exports = __webpack_public_path__ + "img/chinesecompany121.bbb185e9.png";